import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import ListRooms from "./List";
import { ROOMS, AdministrationServicePath } from "utils/constants";
import CreateRooms from "./Create";
import EditRooms from "./Edit";
import ShowRooms from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <MeetingRoomIcon />,
  name: AdministrationServicePath + ROOMS,
  title: "Зали",
  list: <ListRooms />,
  create: <CreateRooms />,
  createPermission: permissions.canCreateRooms,
  edit: <EditRooms />,
  editPermission: permissions.canUpdateRooms,
  show: <ShowRooms />,
  showPermission: permissions.canPreviewRooms,
  permission: permissions.canPreviewRooms,
};
